import { render, staticRenderFns } from "./channelOrderList.vue?vue&type=template&id=0d82aa00&scoped=true"
import script from "./channelOrderList.vue?vue&type=script&lang=js"
export * from "./channelOrderList.vue?vue&type=script&lang=js"
import style0 from "./channelOrderList.vue?vue&type=style&index=0&id=0d82aa00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d82aa00",
  null
  
)

export default component.exports